<template>
    <div class="border rounded-lg p-4 mt-4">
      <h2 class="text-lg font-bold mb-2">Resumen del pedido</h2>
      <div class="flex justify-between mb-2">
        <span>Subtotal:</span>
        <span>${{ subtotal }}</span>
      </div>
      <div class="flex justify-between mb-2" v-if="discount > 0">
        <span>Descuento:</span>
        <span>-${{ discount }}</span>
      </div>
      <div class="flex justify-between mb-2">
        <span>Envío:</span>
        <span>${{ shipping }}</span>
      </div>
      <div class="flex justify-between mb-2">
        <span>Impuestos:</span>
        <span>${{ tax }}</span>
      </div>
      <hr class="my-2">
      <div class="flex justify-between font-bold">
        <span>Total:</span>
        <span>${{ total }}</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      products: {
        type: Array,
        required: true,
      },
    },
    computed: {
      subtotal() {
        return this.products.reduce((acc, product) => acc + product.price * product.quantity, 0);
      },
      discount() {
        // Lógica para calcular el descuento (puede depender de un código promocional o de otras reglas)
        return 0; 
      },
      shipping() {
        // Lógica para calcular el costo de envío
        return 5.99; 
      },
      tax() {
        // Lógica para calcular los impuestos
        return this.subtotal * 0.1; 
      },
      total() {
        return this.subtotal - this.discount + this.shipping + this.tax;
      },
    },
  };
  </script>